module.exports = "/assets/fa8b24de691645b61eda612992245970.svg";